// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // cloudFuncURL: "http://localhost:7071/api",
  cloudFuncURL: 'https://vive-app-api-dev.azurewebsites.net/api',

  defaultRecipients: [
      "btech15252.20@bitmesra.ac.in"  
  ],

  firebaseConfig: {
    apiKey: "AIzaSyCeckR_bl3V274UXlWbEt6BTR7srimZQJA",
    authDomain: "vive-dev-50885.firebaseapp.com",
    projectId: "vive-dev-50885",
    storageBucket: "vive-dev-50885.firebasestorage.app",
    messagingSenderId: "337249039750",
    appId: "1:337249039750:web:e2ee72caa0e07c41e8a807"
  },
  sendEmailUrl:
    'https://sendmail-s6oicjuy6a-uc.a.run.app',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
